import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import Navbar from '../../../components/layout/Navbar/Navbar';
import Sidebar from '../../../components/layout/Sidebar/Sidebar';
import ConcessoesHeader from '../../../components/features/concessoes/ConcessoesHeader';
import ConcessoesContent from '../../../components/features/concessoes/ConcessoesContent';
import { getCargoIdSidebar } from "../../../constants/sidebarConfig";
import apiService from "../../../services/api";

const NAVBAR_HEIGHT = 60;
const SIDEBAR_WIDTH = 300;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #ffffff;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  margin-top: 60px;
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: ${SIDEBAR_WIDTH}px;
  overflow-y: auto;
  height: calc(100vh - ${NAVBAR_HEIGHT}px);
`;

const Concessoes = () => {
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);
  const [sortOrder, setSortOrder] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const location = useLocation();
  const selectedVagaId = location.state?.vagaId ?? location.state?.vaga?.id ?? null;

  const getStatusFilter = () => {
    const path = location.pathname;
    if (path === '/Concedidas') return 'CONCEDIDO';
    if (path === '/Confirmadas') return 'CONFIRMADA';
    if (path === '/NaoConcedidas') return 'RECUSADO';
    if (path === '/ParaAnalise') return 'PENDENTE';
    return null;
  };

  const getHeaderTitle = () => {
    const path = location.pathname;
    if (path === '/Concedidas') return 'Concedidas';
    if (path === '/Confirmadas') return 'Confirmadas';
    if (path === '/NaoConcedidas') return 'Não Concedidas';
    if (path === '/ParaAnalise') return 'Para Análise';
    return 'Todas as Concessões';
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await apiService.getCurrentUser();
        setUser(userData);
        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);
      } catch (err) {
        console.error('Erro ao buscar usuário:', err);
      }
    };

    fetchUser();
  }, []);

  const statusFilter = getStatusFilter();
  const headerTitle = getHeaderTitle();

  return (
    <PageWrapper>
      <Navbar 
        onLogout={apiService.logout}
        showHome={true}
        showNotifications={true}
        showProfile={true}
        showLogout={true}
        user={user}
      />
      <ContentWrapper>
        <Sidebar items={sidebarItems} />
        <MainContent>
          <ConcessoesHeader 
            user={user} 
            onSortChange={setSortOrder} 
            searchValue={searchTerm}
            onSearchChange={setSearchTerm}
            title={headerTitle}
          />
          <ConcessoesContent
            key={location.pathname}
            user={user} 
            sortOrder={sortOrder} 
            searchTerm={searchTerm}
            statusFilter={statusFilter}
            vagaId={selectedVagaId}
          />
        </MainContent>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default Concessoes;
